import Moveable from "../../../../../components/moveable/Moveable";
import PrinterHelper from "../../../../../helpers/PrinterHelper";
import { getLabelItemContent } from "../../label_items/LabelItems";
import {
  StyledLabel,
  StyledLabelItem,
  StyledLabelWrapper,
} from "./PrintLabelStyles";

function PrintLabelView({
  id,
  printerData,
  visitorData,
  zoomPanController,
  onItemSelect,
  onItemPosChange,
  fields,
  images,
  readOnly,
}) {
  return (
    <StyledLabelWrapper $readonly={readOnly}>
      <StyledLabel
        id={`[PRINT_LABEL${readOnly ? "_READONLY" : ""}]${id ? "_" + id : ""}`}
        $readonly={readOnly}
        selected={printerData.label_selected}
        style={{
          width: `${PrinterHelper.getMmToPx(
            printerData.label_width,
            printerData.dpi
          )}px`,
          height: `${PrinterHelper.getMmToPx(
            printerData.label_height,
            printerData.dpi
          )}px`,
        }}
      >
        {printerData.label_items.map((item) => (
          <Moveable
            key={item.id}
            position={{
              x: PrinterHelper.getMmToPx(item.position.x, printerData.dpi),
              y: PrinterHelper.getMmToPx(item.position.y, printerData.dpi),
            }}
            onPositionChange={(pos) =>
              onItemPosChange(item.id, {
                x: PrinterHelper.getMmToPx(
                  pos.x,
                  printerData.dpi,
                  false
                ).toFixed(2),
                y: PrinterHelper.getMmToPx(
                  pos.y,
                  printerData.dpi,
                  false
                ).toFixed(2),
              })
            }
            speed={1 / zoomPanController?.data?.scale}
            disabled={readOnly}
          >
            <StyledLabelItem
              id={`[PRINT_LABEL_ITEM]-${item.id}`}
              selected={item.selected}
              $readonly={readOnly}
              onClick={() => onItemSelect(item.id)}
              style={{
                fontFamily: "Roboto, sans-serif",
                lineHeight: 1,
                fontStretch: "condensed",
                letterSpacing: "-0.5px",
                width: `${PrinterHelper.getMmToPx(
                  item.width,
                  printerData.dpi
                )}px`,
                height: `${PrinterHelper.getMmToPx(
                  item.height,
                  printerData.dpi
                )}px`,
              }}
            >
              {getLabelItemContent(
                item,
                printerData,
                visitorData,
                fields,
                images,
                readOnly
              )}
            </StyledLabelItem>
          </Moveable>
        ))}
      </StyledLabel>
    </StyledLabelWrapper>
  );
}

export default PrintLabelView;
